const PresetColors = [
    'grey',
    'indigo',
    'blue',
    'lightBlue',
    'cyan',
    'green',
    'lime',
    'violet',
    'purple',
    'pink',
    'red',
    'gold',
    'yellow'
];
const PresetStatusColors = [
    'success',
    'processing',
    'error',
    'warning',
    'default'
];
export { PresetColors, PresetStatusColors };
